module.exports = __webpack_public_path__ + "static/media/equipo.ca471aac.jpg";